import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import SVG from "./solid/chevron-right-small.svg";
var ChevronRightSmallSolid_default = forwardRef(
  (props, ref) => /* @__PURE__ */ jsx(SVG, { ref, ...props })
);
export {
  ChevronRightSmallSolid_default as default
};
